import styled from "@emotion/styled/macro";
import { Container as BootstrapContainer, Row, Col } from 'reactstrap';

export const PageContainer = styled(BootstrapContainer)`
  padding-top: 20px;
  padding-bottom: 20px;
  max-width: 80%;
  margin: 0 auto;
  min-height: calc(90vh - 140px);
  display: flex;
  align-items: center;
  justify-content: center;

  @media (max-width: 992px) {
    max-width: 90%;
  }

  @media (max-width: 768px) {
    max-width: 100%;
    padding: 0;
    min-height: auto;
    align-items: flex-start;
    margin-bottom: 0;
  }
`;

export const ProductDetailCard = styled.div`
  padding: 40px;
  background-color: #fff;
  border-radius: 15px;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
  width: 100%;
  margin: 20px 0;

  @media (max-width: 768px) {
    padding: 25px 20px;
    border-radius: 0;
    box-shadow: none;
    margin: 0;
    min-height: calc(80vh - 100px); 
  }
`;

export const BackButton = styled.div`
  cursor: pointer;
  color: #007bff;
  margin-bottom: 25px;
  display: inline-flex;
  align-items: center;
  font-weight: 600;
  font-size: 0.95rem;
  transition: all 0.2s ease-in-out;
  padding: 8px 12px;
  border-radius: 6px;
  
  &:hover {
    color: #0056b3;
    background-color: rgba(0, 123, 255, 0.05);
  }

  &:active {
    transform: scale(0.98);
  }

  @media (max-width: 480px) {
    margin-bottom: 20px;
    font-size: 0.9rem;
    padding: 6px 10px;
  }
`;

export const BackArrow = styled.span`
  font-size: 1.2rem;
  margin-right: 6px;
  line-height: 1;
  display: inline-flex;
  align-items: center;
  position: relative;
  top: -1px;       

  @media (max-width: 480px) {
    font-size: 1.1rem;
    margin-right: 5px;
  }
`;

export const ProductRow = styled(Row)`
  @media (max-width: 768px) {
    flex-direction: column;
    margin: 0;
  }
`;

export const LeftColumn = styled(Col)`
  border-right: 2px solid #eee;
  padding-right: 30px;

  @media (max-width: 992px) {
    padding-right: 20px;
  }

  @media (max-width: 768px) {
    border-right: none;
    border-bottom: 2px solid #f0f0f0;
    padding: 0 0 25px 0;
    margin-bottom: 25px;
  }
`;

export const RightColumn = styled(Col)`
  padding-left: 30px;
  @media (max-width: 992px) {
    padding-left: 20px;
  }

  @media (max-width: 768px) {
    padding: 0;
  }
`;

export const ProductName = styled.h1`
  font-size: 1.75rem;
  font-weight: 800;
  color: #1a1a1a;
  margin-bottom: 12px;
  line-height: 1.3;
  letter-spacing: -0.5px;

  @media (max-width: 992px) {
    font-size: 1.6rem;
  }

  @media (max-width: 768px) {
    font-size: 1.5rem;
    margin-bottom: 10px;
  }

  @media (max-width: 480px) {
    font-size: 1.35rem;
    margin-bottom: 8px;
  }
`;

export const Specification = styled.p`
  font-size: 1rem;
  color: #666;
  margin-bottom: 25px;
  font-style: italic;
  line-height: 1.6;
  font-weight: 400;

  @media (max-width: 768px) {
    font-size: 0.95rem;
    margin-bottom: 20px;
  }

  @media (max-width: 480px) {
    display: none; /* Hide on mobile if content is redundant */
  }
`;

export const PriceSection = styled.div`
  margin-bottom: 30px;
  padding-bottom: 20px;

  @media (max-width: 768px) {
    margin-bottom: 25px;
    padding-bottom: 18px;
  }

  @media (max-width: 480px) {
    margin-bottom: 20px;
    padding-bottom: 15px;
    border-bottom-width: 1px;
  }
`;

export const PriceLabel = styled.small`
  color: #6c757d;
  text-transform: uppercase;
  font-weight: 700;
  display: block;
  margin-bottom: 8px;
  letter-spacing: 1px;
  font-size: 0.75rem;

  @media (max-width: 480px) {
    font-size: 0.7rem;
    margin-bottom: 6px;
  }
`;

export const Price = styled.p`
  font-size: 2.5rem;
  font-weight: 800;
  color: #007bff;
  margin: 0;
  line-height: 1;
  letter-spacing: -1px;

  @media (max-width: 992px) {
    font-size: 2.3rem;
  }

  @media (max-width: 768px) {
    font-size: 2.2rem;
  }

  @media (max-width: 480px) {
    font-size: 2rem;
  }
`;

export const BuyButton = styled.button`
  background: #007bff;
  color: white;
  border: none;
  border-radius: 10px;
  padding: 16px 32px;
  font-size: 1.25rem;
  font-weight: 700;
  cursor: pointer;
  width: 100%;
  box-shadow: 0 6px 20px rgba(0, 123, 255, 0.35);
  transition: all 0.3s ease;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  position: relative;
  overflow: hidden;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 25px rgba(0, 123, 255, 0.45);
  }

  &:active {
    transform: translateY(0);
    box-shadow: 0 4px 15px rgba(0, 123, 255, 0.35);
  }

  @media (max-width: 768px) {
    padding: 15px 28px;
    font-size: 1.15rem;
  }

  @media (max-width: 480px) {
    padding: 14px 24px;
    font-size: 1.05rem;
    border-radius: 8px;
  }
`;

export const SectionTitle = styled.h3`
  color: #007bff;
  margin-bottom: 20px;
  border-bottom: 3px solid #007bff;
  padding-bottom: 10px;
  font-weight: 700;
  font-size: 1.4rem;

  @media (max-width: 768px) {
    font-size: 1.25rem;
    margin-bottom: 18px;
    padding-bottom: 8px;
  }

  @media (max-width: 480px) {
    font-size: 1.15rem;
    margin-bottom: 15px;
    padding-bottom: 6px;
    border-bottom-width: 2px;
  }
`;

export const ExpireInfoCard = styled.div`
  background: linear-gradient(135deg, #e8f3ff 0%, #d6ebff 100%);
  border-radius: 10px;
  padding: 20px;
  box-shadow: 0 2px 10px rgba(0, 123, 255, 0.08);
  border: 1px solid rgba(0, 123, 255, 0.15);
  margin-bottom: 20px;

  @media (max-width: 768px) {
    padding: 18px;
    border-radius: 8px;
    margin-bottom: 18px;
  }

  @media (max-width: 480px) {
    padding: 15px;
    margin-bottom: 15px;
  }
`;

export const DetailLabel = styled.div`
  font-size: 0.85rem;
  color: #007bff;
  font-weight: 700;
  margin-bottom: 8px;
  text-transform: uppercase;
  letter-spacing: 0.5px;

  @media (max-width: 480px) {
    font-size: 0.8rem;
    margin-bottom: 6px;
  }
`;

export const DetailValue = styled.div`
  font-size: 1.05rem;
  font-weight: 600;
  color: #1a1a1a;
  line-height: 1.5;

  @media (max-width: 768px) {
    font-size: 1rem;
  }

  @media (max-width: 480px) {
    font-size: 0.95rem;
  }
`;

export const DetailValueLarge = styled.div`
  font-size: 1.25rem;
  font-weight: 700;
  color: #1a1a1a;
  line-height: 1.4;

  @media (max-width: 768px) {
    font-size: 1.15rem;
  }

  @media (max-width: 480px) {
    font-size: 1.05rem;
  }
`;

export const Divider = styled.hr`
  margin: 25px 0;
  border: 0;
  border-top: 2px solid #e9ecef;

  @media (max-width: 768px) {
    margin: 20px 0;
  }

  @media (max-width: 480px) {
    margin: 18px 0;
    border-top-width: 1px;
  }
`;

export const RegionSection = styled(Row)`
  @media (max-width: 480px) {
    margin: 0;
  }
`;

export const RegionCol = styled(Col)`
  margin-bottom: 18px;
  padding: 15px;
  background-color: #f8f9fa;
  border-radius: 8px;
  border-left: 4px solid #007bff;

  &:last-child {
    margin-bottom: 0;
  }

  @media (max-width: 768px) {
    margin-bottom: 15px;
    padding: 14px;
  }

  @media (max-width: 480px) {
    margin-bottom: 12px;
    padding: 12px;
    border-left-width: 3px;
  }
`;

export const CountryCount = styled.div`
  font-size: 0.8rem;
  color: #6c757d;
  margin-top: 8px;
  font-weight: 600;

  @media (max-width: 480px) {
    font-size: 0.75rem;
    margin-top: 6px;
  }
`;

export const LoadingContainer = styled(BootstrapContainer)`
  text-align: center;
  padding: 50px;
  min-height: 60vh;
  display: flex;
  align-items: center;
  justify-content: center;

  p {
    margin-top: 15px;
    font-size: 1.2rem;
    color: #555;
  }

  @media (max-width: 768px) {
    padding: 40px 20px;

    p {
      font-size: 1.1rem;
    }
  }

  @media (max-width: 480px) {
    padding: 30px 15px;

    p {
      font-size: 1rem;
      margin-top: 10px;
    }
  }
`;

export const ErrorContainer = styled(BootstrapContainer)`
  text-align: center;
  padding: 50px;
  min-height: 60vh;
  display: flex;
  align-items: center;
  justify-content: center;

  p {
    color: #dc3545;
    font-size: 1.1rem;
    font-weight: 500;
  }

  @media (max-width: 768px) {
    padding: 40px 20px;

    p {
      font-size: 1rem;
    }
  }

  @media (max-width: 480px) {
    padding: 30px 15px;

    p {
      font-size: 0.95rem;
    }
  }
`;